export var createAgentAutoRoutingApi = function (baseUrl, http) {
    var autoRoutingUrl = "".concat(baseUrl, "/agents/autoRouting");
    var enableApiUrl = autoRoutingUrl + '/settings/feature/enable';
    var disableApiUrl = autoRoutingUrl + '/settings/feature/disable';
    var declineApiUrl = autoRoutingUrl + '/decline';
    var agentPendingAssigmentApiUrl = autoRoutingUrl + '/pendingAssignment';
    return {
        getAutoRoutingState: function () {
            return http.get(autoRoutingUrl);
        },
        enableFeature: function (dto) {
            return http.post(enableApiUrl, dto);
        },
        disableFeature: function (dto) {
            return http.post(disableApiUrl, dto);
        },
        decline: function (dto) {
            return http.post(declineApiUrl, dto);
        },
        getPendingAssignment: function () {
            return http.get(agentPendingAssigmentApiUrl);
        },
    };
};
//# sourceMappingURL=index.js.map